import React from "react";
class Status404 extends React.Component {
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <this.props._icon icon="FaBug" className="c-placeholder c-green" />,
      Title: "Chyba 404",
      SubTitle: "Požadovaná stránka nebyla nalezena. Stránka buď neexistuje nebo nemáte oprávnění. Zkuste se přihlásit a stránku otevřít znovu",
    });
  }

  render() {
    return (
      <>
      
      </>
    );
  }
}

export default Status404;
